// removed by extract-text-webpack-plugin
module.exports = {"CategoriesContainer":"IqK7g6qbWngT3PHCOOye4","CategoriesItem":"_1YlzgGKZKRsvWze6aWoPsg","Filter":"N3EDuQ78PTbFz1iElxfiR"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Introduction/style.css
// module id = 2021
// module chunks = 0